function populateFootnoteSection() {
    const footnoteTemplate =
        document.querySelector<HTMLTemplateElement>('#footnote-template');
    const footnoteSection = document.querySelector('[data-footnote-section]');
    const footnoteSectionListElement = footnoteSection?.querySelector(
        '[data-footnote-section-list]'
    );
    const footnotes = Array.from(
        document.querySelectorAll<HTMLElement>('[data-footnote]')
    ).filter(footnote => Boolean(footnote.dataset.footnote)) as HTMLElement[];
    if (
        footnoteTemplate &&
        footnoteSection &&
        footnoteSectionListElement &&
        footnotes.length > 0
    ) {
        footnoteSectionListElement.innerHTML = '';
        footnotes.forEach((footnote, index) => {
            // first, delete existing footnote asterisks if this function was previously run
            if (footnote.innerHTML) {
                footnote.innerHTML = footnote.innerHTML?.replace(/\*/g, '');
            }
            const footnoteNode = footnoteTemplate.content.cloneNode(true) as HTMLElement;
            const footnoteTextElement =
                footnoteNode.querySelector('[data-footnote-text]');
            const footnoteText = footnote.dataset.footnote as string;
            if (footnoteTextElement) {
                footnoteTextElement.innerHTML = footnoteText;
                footnoteSectionListElement.appendChild(footnoteNode);
                footnoteSection.classList.remove('gb-hide');
            }
            footnote.insertAdjacentText('beforeend', '*'.repeat(index + 1));
            footnote.setAttribute('aria-description', footnoteText);
        });
    }
}

export { populateFootnoteSection };
